/** @format */
import {endOfMonth, getDate, getDay, isValid, parseISO} from 'date-fns';

import {Discreteness} from 'components/PeriodSelector/model';

import {getDateArray} from 'helpers/dateHelpers';

import {DTO_DATE_FORMAT} from '../constants/common';

interface Options {
  startDate: string;
  endDate: string;
  discreteness: Discreteness;
}

/**
 * Оставит на графике только те точки, которые соответствуют текущей дискретности.
 * @param startDate
 * @param endDate
 * @param discreteness
 */

const getCurrentRechartsDates = ({startDate, endDate, discreteness}: Options): string[] => {
  const dateArray = getDateArray({
    startDate,
    endDate,
    format: DTO_DATE_FORMAT,
  });

  if (discreteness === 'day') {
    return dateArray;
  }

  const discreteDates = dateArray.filter(date => {
    // Это новая точка вывода кумулятивных данных, если подходит по условиям:
    // а) воскресенье; б) конец графика

    if (date === endDate) {
      return true;
    }

    const formattedDate = parseISO(date);
    if (!isValid(formattedDate)) {
      return false;
    }

    if (discreteness === 'week') {
      return getDay(formattedDate) === 0;
    } else if (discreteness === 'month') {
      const end = endOfMonth(formattedDate);
      const currentDateNumber = getDate(formattedDate);
      const endDateNumber = getDate(end);
      return currentDateNumber === endDateNumber;
    }
    return false;
  });

  return discreteDates.length ? discreteDates : dateArray;
};

export {getCurrentRechartsDates};
